<template>
  <div class="web_bottem">
    <div style="margin:0 auto;">
      <span style="color:#939393;">@北京海丰传媒文化有限公司 |</span>
      <a target="_blank" href="http://beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <span > 京ICP备15012901号-1</span>
      </a>
      <span style="color:#939393;"> | </span>
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040087" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <span > 京公网安备 11010502040087号</span>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseBottom',
  data () {
    return {
      jumpType:2,
      columnType:1,
      navShow:''
    }
  },
  methods: {


  },
  mounted() {

  },

}
</script>


<style scoped="page">




  .web_bottem{
    background-color: #2E3139;
    width: 100%;
    height: 120px;
    font-size: 16px;
    color: #C4C4C4;
    line-height: 120px;
    text-align: center;
  }
.web_bottem a{
  color:#12b7f5;}

</style>



// WEBPACK FOOTER //
// src/components/web/BaseBottom.vue